import clsx from 'clsx';
import { jsxs, jsx } from 'react/jsx-runtime';

function cn(...inputs) {
  return clsx(...inputs);
}
function AppShell({
  header,
  sidebar,
  rightPanel,
  sidebarWidth = 240,
  rightPanelWidth = 320,
  children,
  className
}) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn("ds-app-shell", header ? "ds-app-shell--has-header" : void 0, className),
      style: {
        "--ds-shell-sidebar": `${sidebarWidth}px`,
        "--ds-shell-right": rightPanel ? `${rightPanelWidth}px` : "0px"
      },
      children: [
        header && /* @__PURE__ */ jsx("header", { className: "ds-app-shell__header", children: header }),
        sidebar && /* @__PURE__ */ jsx("aside", { className: "ds-app-shell__sidebar", children: sidebar }),
        /* @__PURE__ */ jsx("main", { className: "ds-app-shell__main", children }),
        rightPanel && /* @__PURE__ */ jsx("aside", { className: "ds-app-shell__right", children: rightPanel })
      ]
    }
  );
}
function SidebarNav({ items, activeId, onSelect, footer }) {
  return /* @__PURE__ */ jsxs("nav", { className: "ds-sidebar", "aria-label": "\u0413\u043B\u0430\u0432\u043D\u0430\u044F \u043D\u0430\u0432\u0438\u0433\u0430\u0446\u0438\u044F", children: [
    /* @__PURE__ */ jsx("ul", { className: "ds-sidebar__list", children: items.map((item) => {
      const Icon = item.icon;
      const isActive = item.id === activeId;
      return /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsxs(
        "button",
        {
          type: "button",
          className: cn("ds-sidebar__item", isActive && "ds-sidebar__item--active"),
          "aria-current": isActive ? "page" : void 0,
          onClick: () => onSelect(item.id),
          children: [
            Icon && /* @__PURE__ */ jsx(Icon, { size: 16, className: "ds-sidebar__item-icon" }),
            /* @__PURE__ */ jsx("span", { className: "ds-sidebar__item-label", children: item.label }),
            item.badge != null && /* @__PURE__ */ jsx("span", { className: "ds-sidebar__item-badge", children: item.badge })
          ]
        }
      ) }, item.id);
    }) }),
    footer && /* @__PURE__ */ jsx("div", { className: "ds-sidebar__footer", children: footer })
  ] });
}
function Header({ brand, center, actions, className }) {
  return /* @__PURE__ */ jsxs("div", { className: cn("ds-header", className), children: [
    brand && /* @__PURE__ */ jsx("div", { className: "ds-header__brand", children: brand }),
    center && /* @__PURE__ */ jsx("div", { className: "ds-header__center", children: center }),
    actions && /* @__PURE__ */ jsx("div", { className: "ds-header__actions", children: actions })
  ] });
}

export { AppShell, Header, SidebarNav };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map